import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=53395220&scoped=true&"
import script from "./Manual.vue?vue&type=script&lang=js&"
export * from "./Manual.vue?vue&type=script&lang=js&"
import style0 from "./Manual.vue?vue&type=style&index=0&id=53395220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53395220",
  null
  
)

export default component.exports